<template>
  <div class="shop-top-header" :style="setCssVar">
    <nav class="nav-box">
      <div class="header-menu">
        <div class="flex align-items-center">
          <!--语种-->
          <Dropdown transfer @on-click="changeLanguage" class="languages">
            <div class="lang-text">
              <img :src="flagPath" width="24" height="16" class="cursor" alt="">
              <div class="ml8 font-size-12">{{ selectLang }}</div>
            </div>
            <template #list>
              <Dropdown-menu>
                <Dropdown-item v-for="(item, index) in languageList" :name="item.name" :key="index">
                  <div class="language_item_style">
                    <img :src="item.iconPath" width="24" height="16" class="cursor mr10" alt="">
                    <span class="font-size-12">{{ item.title }}</span>
                    <Icon class="ml8" type="md-checkmark" size="18" color="#FD5425" v-if="flagPath == item.iconPath"/>
                  </div>
                </Dropdown-item>
              </Dropdown-menu>
            </template>
          </Dropdown>
          <template v-if="system === 'shopping'">
            <!--售卖国/地区-->
            <div class="flex align-items-center" v-if="showProductSaleCountrySet">
              <span class="font-size-12">{{ $t('key1000088') }}</span>
              <Select v-model="sellingCountry" filterable size="small" style="width: 100px;" @on-change="sellingCountryChange">
                <Option v-for="item in sellingCountryData" :value="item.twoCode" :key="item.twoCode">{{ item.name }}</Option>
              </Select>
            </div>
            <!--商品发货地-->
            <div class="flex align-items-center ml20">
              <span class="font-size-12">{{ $t('key1000089') }}</span>
              <Select v-model="ymsDeliveryPlaceId" filterable size="small" :style="showProductSaleCountrySet ? {width: '110px'} : {width: '150px'}"
                @on-change="placeOfShipmentChange">
                <Option v-for="(item, index) in placeOfShipmentForGoodsData" :value="item.ymsDeliveryPlaceId" :key="index">{{ item.deliveryPlaceName }}</Option>
              </Select>
            </div>
          </template>
        </div>
        <div class="right-box">
          <span class="header-txt welcome">{{ welcomeText }}</span>
          <template v-if="userInfo">
            <span class="header-txt selectTxt">{{ $t('key1000090') }}{{ $store.state.erpConfig.merchant.merchantId }}</span>
            <span class="header-txt pl10" @click="logout">{{ $t('key1000091') }}</span>
          </template>
          <template v-else>
            <a class="header-txt" :href="loginHref">{{ $t('key1000092') }}</a>
            <span class="line_item">|</span>
            <a class="header-txt" :href="registerHref" target="_blank">{{ $t('key1000042') }}</a>
          </template>
          <span class="line_item">|</span>
          <a class="header-txt" :href="newsListUrl" target="_blank">{{ $t('key1000093') }}</a>
          <template v-if="!isAlibabaDistributor && systemEnvironment === 'yms'">
            <span class="line_item">|</span>
            <span class="header-txt" @click="$refs.gettingStarted.open()">{{ $t('key1000094') }}</span>
          </template>
          <span class="line_item">|</span>
          <a class="header-txt" :href="basicInformationUrl" target="_blank">{{ $t('key1000038') }}</a>
          <span class="line_item">|</span>
          <a class="header-txt" :href="commodityManageUrl" target="_blank">{{ $t('key1000039') }}</a>
          <span class="line_item">|</span>
          <a class="header-txt" :href="myOrderUrl" target="_blank">{{ $t('key1000095') }}</a>
          <span class="line_item">|</span>
          <span class="header-txt" @click="myShoppingCartUrl">{{ $t('key1000096') }}</span>
          <template v-if="!isAlibabaDistributor">
            <span class="line_item">|</span>
            <a :href="helpCenterUrl" class="header-txt" target="_blank">{{ $t('key1000027') }}</a>
          </template>
        </div>
      </div>
    </nav>
    <gettingStarted ref="gettingStarted"></gettingStarted>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import gettingStarted from '@/components/common/gettingStarted';
import {getToken, removeToken} from '@/utils/cookie';
import {getStoreDomainName, getSystemLanguage} from '@/utils/user';
import {
  getHrefPath, isAlibabaDistributor, commonSessionStorage, pageJump, checkLogin,
  getDeliveryAreasAllData, commonLocalStorage, changeUserLanguages, getAllCountrysData
} from "@/utils/common";

export default {
  name: 'headTop',
  mixins: [Mixin],
  data() {
    return {
      selectLang: commonSessionStorage.getItem('selectLang') || '',
      flagPath: commonSessionStorage.getItem('flagPath') || '',
      sellingCountry: 'CN',
      placeOfShipmentForGoodsData: [],
      ymsDeliveryPlaceId: null,
      sellingCountryData: [],
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 登录
    loginHref() {
      let url = '/login.html#/login' + '?u=' + window.location.href;
      let service = '/yms-shopping-service';
      return getHrefPath(url, service);
    },
    // 免费注册
    registerHref() {
      let url = '/login.html#/register';
      let service = '/yms-shopping-service';
      return getHrefPath(url, service);
    },
    // 帮助中心
    helpCenterUrl() {
      let url = '/index.html#/help';
      let service = '/yms-shopping-service';
      return getHrefPath(url, service);
    },
    // 消息
    newsListUrl() {
      let url = '/distributor.html#/newsList';
      let service = '/yms-distributor-service';
      return getHrefPath(url, service);
    },
    // 个人中心
    basicInformationUrl() {
      let url = '/distributor.html#/commodityList';
      let service = '/yms-distributor-service';
      return getHrefPath(url, service);
    },
    // 我的收藏
    commodityManageUrl() {
      let url = '/distributor.html#/commodityList';
      let service = '/yms-distributor-service';
      return getHrefPath(url, service);
    },
    // 我的订单
    myOrderUrl() {
      let url = '/distributor.html#/platformOrder';
      let service = '/yms-distributor-service';
      return getHrefPath(url, service);
    },
    welcomeText() {
      let text = '';
      if (isAlibabaDistributor()) {
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000087');
      } else {
        let pageConfig = commonLocalStorage.getItem('pageConfig') || this.$store.state.pageConfig;
        let sname = pageConfig.sname || '';
        text = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000085')}${sname}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000086')}`;
      }
      return text;
    },
    isAlibabaDistributor() {
      return isAlibabaDistributor()
    },
    setCssVar() {
      return {
        '--subject-color': this.isAlibabaDistributor ? '#2D8CF0' : '#FD5425'
      };
    },
    // 是否展示售卖国
    showProductSaleCountrySet() {
      const obj = commonLocalStorage.getItem('configurationItemInfo') ?? this.$store.state.configurationItemInfo;
      return Number(obj?.enableProductSaleCountrySet) === 1;
    }
  },
  created() {
    let v = this;
    v.getIpAddressCountry();
    getSystemLanguage(v.userInfo).then(({langCode, configureLanguage}) => {
      v.languageList = configureLanguage;
      configureLanguage.map(item => {
        if (item.name === langCode) {
          v.flagPath = item.iconPath;
          v.selectLang = item.title;
        }
      });
      v.systemDefaultLanguage(langCode);
    });
  },
  methods: {
    // 获取IP地址所在地国家
    getIpAddressCountry() {
      if (this.system === 'shopping') {
        if (this.showProductSaleCountrySet) {
          let sellingCountry = commonLocalStorage.getItem('sellingCountry');
          getAllCountrysData('cn', true).then((data) => {
            this.sellingCountryData = data;
            if (sellingCountry) {
              commonLocalStorage.setItem('sellingCountry', sellingCountry);
              this.sellingCountry = sellingCountry;
            } else {
              this.axios.get(api.get_ymsDistributorProductInfo_shopping_queryIpAddressCountryInfo).then(response => {
                if (response.data.code === 0) {
                  let data = response.data.datas || 'CN';
                  commonLocalStorage.setItem('sellingCountry', data);
                  this.sellingCountry = data;
                }
              });
            }
          });
        }
        getDeliveryAreasAllData().then((data) => {
          this.ymsDeliveryPlaceId = null;
          let ymsDeliveryPlaceId = commonLocalStorage.getItem('ymsDeliveryPlaceId');
          this.placeOfShipmentForGoodsData = data;
          if (ymsDeliveryPlaceId) {
            this.ymsDeliveryPlaceId = ymsDeliveryPlaceId;
          } else {
            if (this.placeOfShipmentForGoodsData.length > 0) {
              this.ymsDeliveryPlaceId = this.placeOfShipmentForGoodsData[0].ymsDeliveryPlaceId;
              commonLocalStorage.setItem('ymsDeliveryPlaceId', this.ymsDeliveryPlaceId);
            }
          }
        });
      }
    },
    // 选择售卖国
    sellingCountryChange(val) {
      if (val) {
        commonLocalStorage.setItem('sellingCountry', val);
        this.$store.commit('updateSellingCountry', Date.now())
      }
    },
    // 商品发货地
    placeOfShipmentChange(val) {
      if (val) {
        commonLocalStorage.setItem('ymsDeliveryPlaceId', val);
        this.$store.commit('updatePlaceOfShipment', Date.now())
      }
    },
    // 切换语种
    changeLanguage(lang) {
      const v = this;
      v.$store.commit('setLanguages', lang);
      localStorage.setItem('setLanguages', lang);
      const langItem = v.languageList.find(item => item.name === lang);
      if (!langItem) return;
      const {name, title, iconPath} = langItem;
      const applyCommonStorage = () => {
        localStorage.setItem('lang', name);
        commonSessionStorage.setItem('flagPath', iconPath);
        commonSessionStorage.setItem('selectLang', title);
      };
      const reloadByDomain = () => {
        // 判断是否在店铺域名下
        const hasStoreDomain = getStoreDomainName();
        const delay = hasStoreDomain ? 1200 : 500;
        if (hasStoreDomain) {
          window.location.href = `${window.location.origin}?lang=${name}`;
        }
        setTimeout(() => window.location.reload(), delay);
      };
      // 已登录
      if (Object.keys(v.userInfo).length > 0) {
        changeUserLanguages(lang).then((success) => {
          if (!success) return;
          v.flagPath = iconPath;
          v.selectLang = title;
          applyCommonStorage();
          reloadByDomain();
        });
        return;
      }
      // 未登录
      localStorage.setItem('lang', name);
      reloadByDomain();
    },
    // 退出登录
    logout() {
      let v = this;
      v.axios.get(api.get_logout + getToken('signOut')).then(response => {
        if (response.data.code === 0) {
          removeToken().then(() => {
            setTimeout(() => {
              v.$store.commit('erpConfig', {});
              location.reload();
              // 在商城退出不需要重定向到登录页面
              // let url = deleteTicket(window.location.href);
              // window.location.href = response.data.others.logOutUrl + encodeURIComponent(url);
            }, 1500);
          });
        }
      });
    },
    // 我的购物车
    myShoppingCartUrl() {
      let v = this;
      if (v.system === 'distributor') {
        pageJump('/index.html#/shoppingCartList', '/yms-shopping-service', '_blank');
      } else {
        checkLogin(true).then(() => {
          setTimeout(() => {
            const {href} = v.$router.resolve({
              path: '/shoppingCartList',
            });
            window.open(href, '_blank');
          }, 1200);
        });
      }
    },
  },
  components: {
    gettingStarted
  }
};
</script>

<style lang="less" scoped>
@import "src/assets/styles/shopping/common";

.shop-top-header {
  width: 100%;
  background: #FFFFFF;
  border-bottom: 1px solid #D7D7D7;

  .top_banner_style {
    width: 100%;
    display: flex;
    justify-content: center;
    background-color: #FBDBE0;
    cursor: pointer;
  }

  .nav-box {
    display: flex;
    background-color: #F2F2F2;
    color: #333333;

    .header-menu {
      width: 1400px;
      margin: 0 auto;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .right-box {
        display: flex;
        justify-content: flex-end;
      }

      .welcome {
        padding-right: 5px;
      }

      .header-txt {
        cursor: pointer;
        display: inline-block;
        font-size: 12px;
        font-family: PingFang SC;
        color: #777777;
        display: flex;
        align-items: center;

        .user-icon {
          margin-right: 5px;
          font-weight: initial;
          color: #777777;
        }

        &:hover {
          color: var(--subject-color);

          .user-icon {
            color: var(--subject-color);
          }
        }
      }

      .selectTxt {
        color: var(--subject-color);
      }

      .line_item {
        color: #c3c1c1;
        margin: 0 10px;
      }
    }
  }

  .header-conter {
    width: 1200px;
    margin: 0 auto;
    position: relative;
  }
}

.header-bottom {
  border-bottom: 2px solid var(--subject-color);
}

.lang-text {
  display: flex;
  width: 100px;
  line-height: 32px;
  color: #777777;
  cursor: pointer;
  align-items: center;
}

.languages {
  /deep/ .ivu-dropdown-item {
    padding: 0 8px 0 8px;

    .language_item_style {
      display: flex;
      align-items: center;
      margin-bottom: 8px;

      span {
        display: inline-block;
      }
    }
  }
}
</style>
